module.exports = __webpack_public_path__ + "assets/bbf21cbb70ac7f3c6b88a32dd90d7d3e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_50.mp3
 ** module id = 34
 ** module chunks = 0
 **/